//import React, { useState } from 'react'
//import ReactApexChart from 'react-apexcharts';
import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const TraitChart = ({currentRange}) => {
  let traitCategories= [];
  const [chartData, setChartData] = useState({
    series: [
      {
        name: "Iterations",
        data: [200, 330, 448, 170, 122],
      },
    ],
    options: {
      chart: {
        type: "bar",
        width: "100%",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 8,
          horizontal: false,
          columnWidth: "35%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: ["Trait1", "Trait2", "Trait4", "Trait4", "Trait4","Trait4"],
        labels: {
          style: {
            fontSize: "8px",
          },
        },
        lines: {
          show: true,
        },
      },
      yaxis: {
        show: false,
      },
      colors: ["#A572FF"],
    },
  });

  const userData = useSelector((state) => state.userSlice);

  var uuid = userData?.user?.uuid;

  const configData = useSelector((state) => state.configSlice);

  const fetchinsightgraph = async () => {

    const response = await axios.get(
      `${configData?.config?.apiBaseUrl}/api/traitcount/${uuid}/${currentRange}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      }
    );

    traitCategories = response?.data?.traitWithCount?.map((e=>e?.name?.split(' ')[0]));
    
    let count = [];
    let traits = [];

    for(var i=0;i<response?.data?.traitWithCount?.length;i++){
      traits.push(response.data.traitWithCount[i].name)
      count.push(response.data.traitWithCount[i].count)
    }

    setChartData({
      series: [
        {
          name: "Iterations",
          data: count,
        },
      ],
      options: {
        chart: {
          type: "bar",
          width: "100%",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            horizontal: false,
            columnWidth: "45%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
    
          categories: traitCategories 
        },
        colors: ["#A572FF"],
        tooltip: {
          enabled: true,
          shared: false,
          followCursor: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return (
              '<div class="custom-tooltip">' +
              "<span>" +
              traits[dataPointIndex] +
              ": " +
              series[seriesIndex][dataPointIndex] +
              "</span>" +
              "</div>"
            );
          },
        },
      },
    });
  };

  useEffect(() => {
    fetchinsightgraph();
  }, [currentRange]);

  return (
    <>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height="auto"
        />
      </div>
    </>
  );
};

export default TraitChart;
